module.exports = __webpack_public_path__ + "static/media/logo-light.09f5e051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-light.png
// module id = 514
// module chunks = 0